import {
  handleResp,
  getURLWithQueryParams,
  getDefaultHeaders,
  extendFetchOptions,
} from "./utils";
import type {
  WrappedCashifyFunction,
  WrappedCashifyPageableQuery,
  CommonResponse,
  GenericResponse,
  Sortable,
} from "./utils";

export interface AdminGroupService {
  listAdminGroup: ReturnType<typeof listAdminGroup>;
  postAdminGroup: ReturnType<typeof postAdminGroup>;
  getAdminGroupDetail: ReturnType<typeof getAdminGroupDetail>;
  putAdminGroupDetail: ReturnType<typeof putAdminGroupDetail>;
  deleteAdminGroupDetail: ReturnType<typeof deleteAdminGroupDetail>;
};

// Admin Group
export interface AdminGroupSearchCriteria extends Sortable {
  id?: number;
  ids?: number[];
  groupName?: string;
  "createTime.from"?: string;
  "createTime.to"?: string;
  createAdmin?: string;
  "lastUpdateTime.from"?: string;
  "lastUpdateTime.to"?: string;
  lastUpdateAdmin?: string;
  withRoleId?: number;
};

export interface AdminGroupDTO {
  id: number;
  tenantId: number;
  groupName: string;
  createTime?: string;
  createAdmin?: string;
  lastUpdateTime?: string;
  lastUpdateAdmin?: string;
};

export interface AdminGroupDetail extends AdminGroupDTO {
  roleIds?: number[];
};

export interface CreateAdminGroupRequest {
  groupName: string;
  roleIds?: number[];
};

export interface UpdateAdminGroupRequest {
  id: number;
  detail: CreateAdminGroupRequest;
};

export const listAdminGroup: WrappedCashifyPageableQuery<AdminGroupSearchCriteria, AdminGroupDTO> = ({ urlPrefix, options }) => {
  return async (queryParams) => {
    let url = getURLWithQueryParams(
      `${urlPrefix}/api/v1/admin-group`,
      queryParams,
    );
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const postAdminGroup: WrappedCashifyFunction<CreateAdminGroupRequest, CommonResponse> = ({ urlPrefix, options }) => {
  return async (request) => {
    let url = `${urlPrefix}/api/v1/admin-group`;
    let opts = extendFetchOptions(
      {
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          ...getDefaultHeaders(),
          "Content-Type": "application/json",
        },
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const getAdminGroupDetail: WrappedCashifyFunction<{ id: number }, GenericResponse<AdminGroupDetail>> = ({ urlPrefix, options }) => {
  return async ({ id }) => {
    let url = `${urlPrefix}/api/v1/admin-group/${id}`;
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const putAdminGroupDetail: WrappedCashifyFunction<UpdateAdminGroupRequest, CommonResponse> = ({ urlPrefix, options }) => {
  return async ({ id, detail }) => {
    let url = `${urlPrefix}/api/v1/admin-group/${id}`;
    let opts = extendFetchOptions(
      {
        method: "PUT",
        headers: {
          ...getDefaultHeaders(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(detail),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const deleteAdminGroupDetail: WrappedCashifyFunction<{ id: number }, CommonResponse> = ({ urlPrefix, options }) => {
  return async ({ id }) => {
    let url = `${urlPrefix}/api/v1/admin-group/${id}`;
    let opts = extendFetchOptions(
      {
        method: "DELETE",
        headers: getDefaultHeaders(),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};
